import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { updateProps } from '../../../stores/newsfeed/actions';
import CommentIcon from 'material-ui/svg-icons/communication/chat-bubble-outline';
import ThumbUpIcon from 'material-ui/svg-icons/action/thumb-up';

import { IconButton } from 'material-ui';

import SharePost from './sharePost';
import Comments from './comments';

class ActionBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shareLinksOpen: false,
      viewingComments: !!props.displayType,
    };
  }

  trackShareClicks(source) {
    this.props.trackEvent({ name: `[newsfeed] shared to ${source}` });
  }

  render() {
    const {
      shareableLink,
      companyName,
      message,
      postId,
      updatePost,
      numOfLikes,
      liked, // did signed in user like the post
      displayType,
      changeRoute,
      viewingCompanyId,
      comments,
      updateProp,
      numOfComments,
      trackEvent,
    } = this.props;

    const { shareLinksOpen, viewingComments } = this.state;

    return (
      <div style={{ paddingBottom: viewingComments ? '0' : '2%', marginTop: '8px', display: 'flex', alignItems: 'flex-end', width: '100%', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', cursor: 'pointer', height: '18px', padding: '0 2%' }}>
          <span style={{ display: 'flex', marginTop: '3px' }}>
            <IconButton
              style={{ padding: 0, margin: 0, height: '20px', width: '20px', display: 'inline-block' }}
              onTouchTap={() => {
                if (displayType === 'publicPostPage' && !viewingCompanyId) changeRoute(`/post/${postId}`);
                else if (liked) updatePost('unlike');
                else updatePost('like');
              }}
            >
              <span style={{ height: '14px', width: '14px' }}>
                <ThumbUpIcon
                  color={liked ? 'rgb(0, 188, 212)' : 'rgba(0, 0, 0, 0.54)'}
                  style={{ height: '14px', width: '14px' }}
                />
              </span>
            </IconButton>
            {
              numOfLikes > 0 && <span style={{ marginTop: '-3px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)', cursor: 'default' }}>{numOfLikes}</span>
            }
          </span>
          <span style={{ marginLeft: '5px', display: 'flex', marginTop: '3px' }}>
            <IconButton
              style={{ padding: 0, margin: 0, height: '20px', width: '20px', display: 'inline-block' }}
              onTouchTap={() => {
                if (displayType === 'publicPostPage' && !viewingCompanyId) changeRoute(`/post/${postId}`);
                else {
                  this.setState({ viewingComments: !viewingComments });
                  updateProp({ postComment: {
                    comment: '',
                    postId,
                    lastCommentId: '',
                    hasMoreComments: numOfComments > comments.length,
                    loading: false,
                  } });
                }
              }}
            >
              <span style={{ height: '14px', width: '14px' }}>
                <CommentIcon
                  color={'rgba(0, 0, 0, 0.54)'}
                  style={{ height: '14px', width: '14px' }}
                />
              </span>
            </IconButton>
            {
              comments.length > 0 && <span style={{ marginTop: '-3px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)', cursor: 'default' }}>{numOfComments}</span>
            }
          </span>
          <span style={{ marginLeft: '5px', display: 'flex' }}>
            <SharePost
              shareLinksOpen={shareLinksOpen}
              companyName={companyName}
              shareableLink={shareableLink}
              postId={postId}
              message={message}
              openShareLinks={() => {
                if (!shareLinksOpen) {
                  trackEvent({ name: '[newsfeed] click share button' });
                }
                this.setState({ shareLinksOpen: !shareLinksOpen });
              }}
              trackShareClicks={(socialMediaType) => this.trackShareClicks(socialMediaType)}
            />
          </span>
        </div>
        <Comments
          open={viewingComments}
          changeRoute={changeRoute}
          postId={postId}
          comments={comments}
          displayType={displayType}
          numOfComments={numOfComments}
        />
      </div>
    );
  }
}

ActionBar.propTypes = {
  shareableLink: PropTypes.string,
  isEditable: PropTypes.bool,
  metadata: PropTypes.array,
  companyName: PropTypes.string,
  message: PropTypes.string,
  postId: PropTypes.string,
  updatePost: PropTypes.func,
  numOfLikes: PropTypes.number,
  liked: PropTypes.bool,
  displayType: PropTypes.string,
  changeRoute: PropTypes.func,
  viewingCompanyId: PropTypes.string,
  comments: PropTypes.array,
  updateProp: PropTypes.func,
  numOfComments: PropTypes.number,
  trackEvent: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateProps(...args)),
  trackEvent: (payload) => dispatch({
    type: 'TRACK_EVENT',
    payload,
  }),
});

export default connect(null, mapDispatchToProps)(ActionBar);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/actionBar/container.jsx